import React from 'react';

import ProviderVariantContext from "./ProviderVariantContext";
import {ProviderVariantType} from "root/Common/Constants/ProviderVariantType";

const ProviderVariantProvider = ({dataset, children}) => {

    const getLoggedInProviderVariant = () =>
    {
        if ( dataset.provider_variant === undefined )
        {
            return ProviderVariantType.PASSPORT ;
        }
        else
        {
            return +dataset.provider_variant ;
        }
    }

    return (
        <ProviderVariantContext.Provider
            value={{
                provider_variant: getLoggedInProviderVariant()
            }}
        >
        {children}
        </ProviderVariantContext.Provider>
    )
}

export default ProviderVariantProvider ;
